import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DropdownComponent),
      multi: true,
    },
  ],
})
export class DropdownComponent implements ControlValueAccessor {
  @Input() options: string[] = [];
  @Input() value: string = '';
  @Input() placeholder = 'Please select';
  @Input() disabled = false;
  @Input() hasError = false;
  @Input() fullWidth = false;
  isShowingDropdown = false;

  propagateChange = (_: any) => {};
  onTouch = (_: any) => {};

  constructor() {}

  get hasValue(): boolean {
    return this.value != '' && this.value !== this.placeholder;
  }

  onClickOutside(event: any) {
    this.isShowingDropdown = false;
  }

  toggleDropdown(event: any) {
    if (this.disabled) {
      return;
    }

    this.isShowingDropdown = !this.isShowingDropdown;
    // prevent triggering onClickOutside()
    event.preventDefault();
    event.stopPropagation();
  }

  onOptionSelected(index: number) {
    if (this.disabled) {
      return;
    }

    this.value = this.options[index];
    this.propagateChange(this.value);
    this.isShowingDropdown = false;
  }

  // region ControlValueAccessor

  writeValue(value: any): void {
    if (value !== undefined) {
      this.value = value;
    }
  }

  registerOnChange(fn: any) {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouch = fn;
  }

  // endregion ControlValueAccessor
}
